import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import archiveFill from '@iconify/icons-eva/archive-fill';
import phoneCallFill from '@iconify/icons-eva/phone-call-fill';
import roundMarkEmailRead from '@iconify/icons-ic/round-mark-email-read';
// material
import { styled } from '@material-ui/core/styles';
import { Tooltip, IconButton } from '@material-ui/core';
import ChatIcon from '@mui/icons-material/Chat';
// ----------------------------------------------------------------------
import messageSquareFill from '@iconify/icons-eva/message-square-fill';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
const RootStyle = styled('div')(({ theme }) => ({
  // height: 40,
  // zIndex: 99,
  // opacity: 0,
  // margin: 'auto',
  display: 'flex',
  // position: 'absolute',
  // alignItems: 'center',
  // top: theme.spacing(1),
  // right: theme.spacing(1),
  // bottom: theme.spacing(1),
  // justifyContent: 'center',
  // padding: theme.spacing(0, 0.75),
  // boxShadow: theme.customShadows.z12,
  // borderRadius: theme.shape.borderRadius,
  // backgroundColor: theme.palette.background.paper,
  // transition: theme.transitions.create('opacity')
}));

// ----------------------------------------------------------------------

ContactItemAction.propTypes = {
  handleArchive: PropTypes.func,
  handleDelete: PropTypes.func,
  handleMarkRead: PropTypes.func,
  handleHidden: PropTypes.func
};

export default function ContactItemAction({ handleOpenModalSend, handleCall, handleDelete, handleChat,handleOpenModalTicket, ...other }) {
  const CONTACT_ACTIONS = [
    {
      name: 'Chat',
      icon: messageSquareFill,
      action: handleChat,
      color: '#33CCFF'
    },
    {
      name: 'Gọi diện',
      icon: phoneCallFill,
      action: handleCall,
      color: '#54D62C'
    },
    {
      name: 'Gửi tin nhắn',
      icon: "ion:send",
      action: handleOpenModalSend,
      color: '#FFCC00'
    },
    {
      name: 'Thêm phiếu ghi',
      icon: "mdi:ticket",
      action: handleOpenModalTicket,
      color: '#F08832'
    },
    {
      name: 'Xóa',
      icon: trash2Fill,
      action: handleDelete,
      color: '#FF0000'
    },


  ];

  return (
    <RootStyle {...other}>
      {CONTACT_ACTIONS.map((action) => (
        <Tooltip key={action.name} title={action.name}>
          <IconButton
            size="small"
            onClick={action.action}
            sx={{
              mx: 0.25,
              '&:hover': {
                color: 'text.primary'
              }
            }}
          >
            <Icon icon={action.icon} width={22} height={22} color={action.color} />
          </IconButton>
        </Tooltip>
      ))}
    </RootStyle>
  );
}
